import * as React from "react";
import { DateUtils } from "@grandvisionhq/utils";
import { useActiveTimeFilters } from "../../../../../hooks/v3/hooks/use-active-time-filters.js";
import { useAppointmentContext } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
const useGetAvailabilityStoresNearbyQueryVariables = (date) => {
  const [{ getAvailabilityTimeFilters }] = useActiveTimeFilters();
  const [, { store, type }] = useAppointmentContext();
  return React.useMemo(() => {
    if (!date) {
      return void 0;
    }
    const { startTime, endTime } = getAvailabilityTimeFilters(date);
    const getHoursAndMinutes = (date2) => {
      const dateString = DateUtils.toLocalDateTime(date2);
      const hours = dateString.split("T")[1]?.split(":")[0];
      const minutes = dateString.split("T")[1]?.split(":")[1];
      return `${hours}:${minutes}`;
    };
    const startTimeString = startTime ? getHoursAndMinutes(startTime) : void 0;
    const endTimeString = endTime ? getHoursAndMinutes(endTime) : void 0;
    return type?.id && store?.lon && store?.lat && date ? {
      appointmentTypeId: type.id,
      longitude: store.lon,
      latitude: store.lat,
      /* startDate is the selected date and endDate is
        one week later from startDate */
      startDate: DateUtils.toLocalDate(date).split("T")[0] ?? "",
      endDate: DateUtils.toLocalDate(DateUtils.shiftDate(date, "week", 1)).split("T")[0],
      startTime: startTimeString,
      endTime: endTimeString
    } : void 0;
  }, [getAvailabilityTimeFilters, date, type?.id, store?.lon, store?.lat]);
};
export {
  useGetAvailabilityStoresNearbyQueryVariables as default
};
//# sourceMappingURL=useGetAvailabilityStoresNearbyQueryVariables.js.map
